import axios from "axios";
import { router } from "@/router";
import { ElMessage } from "element-plus";
import { getUserInf } from "@/shard/login-info-manager";
import utils from "../utils/utils";

const httpRequest = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL,
  timeout: 10000, // 请求超时时间
  withCredentials: true // 允许携带 Cookie
});

httpRequest.interceptors.request.use(
  (config) => {
    // 在发送请求之前修改请求头
    let userInfo = getUserInf();
    if (userInfo) {
      // 1、接收BASE64串  2、使用atob()解码BASE64串转为二进制数组  3、将二进制转为UTF-8字符串
      var userId = userInfo.userId;
      var userName = userInfo.loginName;
      //自定义请求头：客户端类型
      config.headers["X-Client-Type"] = "SRC-WEB";
      config.headers["X-Auth-Type"] = "tokenAuth";
      config.headers["accessToken"] = userInfo.authToken;

      if (config.method === "post" && !(config.data instanceof FormData)) {
        config.data["modifyUid"] = userId;
        config.data["modifyName"] = userName;
        config.data["modifyDate"] = utils.formatDate(new Date(),"YYYY-MM-DD HH:mm:ss");
      }
    }
    return config; // 返回修改后的配置对象
  },
  (error) => {
    // 处理请求错误（可选）
    ElMessage.error("网络异常，请检测请求地址等信息!" + error);
    return Promise.reject(error);
  }
);


httpRequest.interceptors.response.use(
  (response) => {
    // 对响应数据进行一些处理（可选）
    return response;
  },
 
  (error) => {
    const { response } = error;
    console.log("error:",JSON.stringify(error));

    if (response) {
      // 根据 HTTP 状态码进行不同的处理
      switch (response.status) {
        case 400:
          ElMessage.error("客户端请求错误!"+ error);
          break;
        case 401: // 未认证
          ElMessage.error("登录信息已过期，请重新登录");
          router.push("/login");
          break;
        case 403: // 禁止访问
          sessionStorage.removeItem("accessToken");
          router.push("/login");
          ElMessage.error("禁止访问!" + error);
          break;
        case 404: // 禁止访问
          ElMessage.error("未找到资源!"+ error);
          break;
        case 405:
          ElMessage.error("请求方法未允许!"+ error);
          break;
        case 408:
          ElMessage.error("请求超时!"+ error);
          break;
        case 500:
          ElMessage.error(`${response?.data?.errorMessage}[ErrorCode:${response?.data?.errorCode}]` || "服务器内部错误，请稍后重试");
          break;
        case 501:
          ElMessage.error("网络未实现!"+ error);
          break;
        case 502:
          ElMessage.error("网关错误，请稍后重试!"+ error);
          break;
        case 503:
          ElMessage.error("服务不可用!"+ error);
          break;
        case 504:
          ElMessage.error("网络超时!"+ error);
          break;
        case 505:
          ElMessage.error("http版本不支持该请求!"+ error);
          break;
        default:
          ElMessage.error("服务器异常!" + error);
          break;
      }
    }
    // 返回 Promise.reject() 以便上层调用者可以捕获到错误
    return Promise.reject(error);
  }
);





export default httpRequest;
